import Navbar from '../navbar/Navbar';
import Sidemenu from '../sidemenu/Sidemenu';
import { Button, Typography, MenuItem, Select, Box, IconButton, Menu, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Snackbar } from '@mui/material';
import React, { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Grid
} from '@mui/material';
import threeDots from '../../assets/images/threeDots.svg';
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import axios from 'axios';
// import AddDocument from './addDriverDocument';
import AddDocument from '../driverDocuments/addDriverDocument.jsx';
import { useNavigate } from 'react-router-dom';
import TokenError from '../tokenError';
import { makeGetRequestToUrl, makePostRequestToUrl } from '../commonFunc.jsx';
import config from '../../config/config.js';
var constants = require('../../constant');

const DeleteAccount = () => {
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();

    const token = localStorage.getItem('token');
    const ctId = localStorage.getItem('ctId');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [rows, setRows] = useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('vehicleName');
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [UserTypeFilter, setUserTypeFilter] = useState('1');
    // const [cityFilter, setCityFilter] = useState(ctId ? ctId : cities[0].city_id);
    const [cityFilter, setCityFilter] = useState(() => {
        const cityExists = cities.some(city => city.city_id === ctId);
        return cityExists ? ctId : (cities.length > 0 ? cities[0].city_id : null);
    });
    
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [paginationInfo, setPaginationInfo] = useState({ total: 0, page_count: 1 });
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [actionType, setActionType] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleFilterChange = (filterType, value) => {
        console.log(value, "value")
        if (filterType === 'city') setCityFilter(value);
        if (filterType === 'user_type') setUserTypeFilter(value);
    };

    const rowArray = Array.isArray(rows) ? rows : [];
    const totalEntries = rowArray.length;
    // const totalPages = Math.ceil(totalEntries / rowsPerPage);
    const currentPage = Math.min(page, totalPages - 1); // Avoid invalid page numbers

    const handleApprove = (row) => {
        setActionType('approve');
        setSelectedUser(row);
        setOpenConfirmDialog(true);
    };

    const handleReject = (row) => {
        setActionType('reject');
        setSelectedUser(row);
        setOpenConfirmDialog(true);
    };

    const handleConfirmAction = async() => {
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            request_id: selectedUser.id,
            status: actionType=='approve' ? 2 : 3,
        };
        try {
            const url = operationsUrl + '/panel/delete_account_request_actions';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                fetchDeleteAccountRequestData();
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }
            setOpenConfirmDialog(false);
        } catch (error) {
            console.error('Error', error);
            setMessage(error);
        }
        // if (!selectedUser) return;

        // const updatedRows = rows.map((r) =>
        //     r.user_id === selectedUser.user_id
        //         ? { ...r, status: actionType === 'approve' ? 2 : 3 }
        //         : r
        // );
        // setRows(updatedRows);
        // setOpenConfirmDialog(false);
    };


    const fetchDeleteAccountRequestData = async () => {
        try {
            const url = serverUrl + '/panel/fetch_delete_account';
            const token = localStorage.getItem('token');

            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                user_type: UserTypeFilter,
                timestamp: timestamp
            };
            const response = await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setRows(response.data);
            }
            if(response.flag==102){
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    };
    useEffect(() => {
        fetchDeleteAccountRequestData();
    }, [cityFilter, UserTypeFilter]);

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    return (
        <>
            <Dialog
                open={openConfirmDialog}
                onClose={() => setOpenConfirmDialog(false)}
                aria-labelledby="delete-booking-dialog-title"
                aria-describedby="delete-booking-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '10px'
                    }
                }}
            >
                <DialogTitle id="delete-booking-dialog-title" sx={{fontWeight:'bold'}}>{actionType === 'approve' ? 'Approve Request' : 'Reject Request'}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="delete-booking-dialog-description">
                        Are you sure you want to {actionType} deletion request for <b>{selectedUser?.user_name}</b>?
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                    <Button
                        onClick={() => setOpenConfirmDialog(false)}
                        sx={{
                            color: '#6B7280', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            minWidth:'80px',
                            border: '1px solid #D1D5DB',
                            '&:hover': {
                                backgroundColor: '#F3F4F6',
                                borderColor: '#9CA3AF'
                            }
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirmAction}
                        color="error"
                        variant="contained"
                        sx={{ 
                            backgroundColor: actionType === 'approve' ? '#0DBA78' : '#D14545', 
                            borderRadius:'8px', 
                            minWidth:'80px',
                            justifyContent:'center',
                            textTransform:'none',
                            // '&:hover': {
                            //     backgroundColor: '#DC2626'
                            // }
                        }}
                        autoFocus
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
            <div>
                {tokenExpired && (<TokenError />)}

                <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                    Delete Account Request
                </Typography>

                <Grid container spacing={2} alignItems="center" style={{ marginTop: '1%', marginBottom: '2%' }}>
                    <Grid item>
                        <Select
                            value={cityFilter}
                            onChange={(e) => handleFilterChange('city', e.target.value)}
                            displayEmpty
                            style={{
                                width: '220px',
                                height: '50px',
                                borderRadius: '8px',
                                backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                            }}
                        >
                            <MenuItem value="">Select City</MenuItem>
                            {cities.map((city) => (
                                <MenuItem key={city.city_id} value={city.city_id}>
                                    {city.city_name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    <Grid item>
                        <Select
                            value={UserTypeFilter}
                            onChange={(e) => handleFilterChange('user_type', e.target.value)}
                            displayEmpty
                            style={{
                                width: '220px',
                                height: '50px',
                                borderRadius: '8px',
                                backgroundColor: UserTypeFilter ? '#F9F9F9' : '#FFFFFF',
                            }}
                        >
                            {/* <MenuItem value="">All</MenuItem> */}
                            <MenuItem value="1">User</MenuItem>
                            <MenuItem value="2">Driver</MenuItem>
                        </Select>
                    </Grid>
                    {/* <Grid item style={{ marginLeft: '4%' }}>
                    <Button
                        variant="contained"
                        onClick={applyOrResetFilter}
                        style={{
                            width: '185px',
                            height: '50px',
                            marginRight: '1px',
                            backgroundColor: isFilterApplied ? '#F5BB19' : '#0065FF',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        {isFilterApplied ? 'Reset Filter' : 'Apply Filter'}
                    </Button>
                </Grid> */}
                </Grid>

                {/* Documents Table */}
                <TableContainer className="table-container" style={{maxHeight:'60vh'}}>
                    <Table stickyHeader className="scrollable-table">
                        <TableHead>
                            <TableRow>
                                {UserTypeFilter == 1 ? <TableCell component="th" align="center" className="table-header" style={{ width: '12%' }}>
                                    <TableSortLabel
                                        active={orderBy === 'user_id'}
                                        direction={orderBy === 'user_id' ? order : 'asc'}
                                        onClick={() => handleRequestSort('user_id')}
                                    >
                                        User Id
                                    </TableSortLabel>
                                </TableCell> : <TableCell align="center" className="table-header" style={{ width: '10%' }}>
                                    Driver Id
                                </TableCell>}
                                {UserTypeFilter == 1 ? <TableCell component="th" align="center" className="table-header" style={{ width: '12%' }}>
                                    User Name
                                </TableCell> : <TableCell align="center" className="table-header" style={{ width: '10%' }}>
                                    Driver Name
                                </TableCell>}
                                <TableCell align="center" className="table-header" style={{ width: '15%' }}>Reason</TableCell>
                                <TableCell align="center" className="table-header" style={{ width: '15%' }}>Feedback</TableCell>
                                <TableCell align="center" className="table-header" style={{ width: '15%' }}>Status</TableCell>
                                <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row) => (
                                    <TableRow key={row.user_id}>
                                        <TableCell align="center">{row.user_id}</TableCell>
                                        <TableCell align="center">{row.user_name}</TableCell>
                                        <TableCell align="center">{row.reason}</TableCell>
                                        <TableCell align="center">{row.feedback}</TableCell>
                                        <TableCell align="center">
                                            <Typography sx={{ color: row.status === 1 ? '#AC8312' : row.status === 2 ? '#0DBA78' : '#D14545' }}>
                                                {row.status === 1 ? 'Pending' : row.status === 2 ? 'Approved' : 'Rejected'}
                                            </Typography>
                                        </TableCell>
                                        {/* <TableCell align="center">
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <IconButton
                                                aria-label="more options" 
                                                size="small"
                                                onClick={(e) => handleMenuOpen(e, row)}
                                                sx={{ marginLeft: '4px' }}
                                            >
                                                <img src={threeDots} alt="threeDots"/>
                                            </IconButton>
                                        </Box>
                                        
                                        
                                    </TableCell> */}
                                        <TableCell align="center">
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                {row.status === 1 ? (
                                                    <>
                                                        <Button
                                                            variant="contained"
                                                            color="success"
                                                            size="small"
                                                            sx={{ marginRight: '8px', textTransform: 'none' }}
                                                            onClick={() => handleApprove(row)}
                                                        >
                                                            Approve
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            color="error"
                                                            size="small"
                                                            sx={{ textTransform: 'none' }}
                                                            onClick={() => handleReject(row)}
                                                        >
                                                            Reject
                                                        </Button>
                                                    </>
                                                ) : (
                                                    '--'
                                                )}
                                            </Box>
                                        </TableCell>

                                    </TableRow>
                                ))
                            }
                            {rows.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={10} align="center">
                                        <Typography variant="body1">No data found</Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>

                    {/* Pagination */}
                    <div className="custom-pagination">
                        <div className="pagination-info">
                            {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                                (page + 1) * rowsPerPage,
                                rows.length
                            )} of ${rows.length} entries`}
                        </div>
                        <div className="pagination-controls">
                        <button
                            onClick={() => handleChangePage(null, page - 1)}
                            disabled={page === 0}
                            className="pagination-arrow"
                        >
                            <img src={prevIcon} alt="Previous" />
                        </button>
                            <div className="pagination-numbers">
                                {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                    <button
                                        key={index}
                                        onClick={() => handleChangePage(null, index)}
                                        className={`pagination-number ${
                                            page === index ? 'active' : ''
                                        }`}
                                    >
                                        {index + 1}
                                    </button>
                                ))}
                            </div>
                            <button
                                onClick={() => handleChangePage(null, page + 1)}
                                disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                                className="pagination-arrow"
                            >
                                <img src={nextIcon} alt="Next" />
                            </button>
                        </div>
                    </div>
                </TableContainer>

            </div>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
                
        </>
    );
};

export default DeleteAccount;